import { FunctionComponent } from "react";
import { OldAccountScreensProps } from "../useOldAccountDetails";
import ScrollableContainer from "../../../layout/scrollable-container";
import Container from "../../../layout/container";

import Footer from "../../../components/footer";

import TransitionWrapper from "../../../components/transition-wrapper/TransitionWrapper";

import { VectorWrapperDiv } from "../../../components/vector-wrapper/styles";
import HeadingContainer from "../../../layout/heading-container";
import { HeadlineMedium } from "../../../components/font";
import { Button, IllustrationTrain } from "@manifesthhqinc/ui-library";

const OldAccountFinishScreen: FunctionComponent<OldAccountScreensProps> = (props: OldAccountScreensProps) => {
  const { currentSourceAccountStep, onClickContinue, partnerConfig, sourceOfDestination } = props;

  return (
    <TransitionWrapper>
      <ScrollableContainer name={currentSourceAccountStep}>
        <Container>
          <HeadingContainer paneVariant="vector" withProgressBar>
            <HeadlineMedium $textAlign="center">
              {sourceOfDestination === "CLIENT_FIX"
                ? `Let’s review your destination account`
                : `Let’s find the best place for your old account`}
            </HeadlineMedium>
          </HeadingContainer>
          <VectorWrapperDiv $marginTop={-30} $marginBottom={-20}>
            <IllustrationTrain width={250} />
          </VectorWrapperDiv>
        </Container>
      </ScrollableContainer>
      <Footer>
        <p className="text-center">
          {sourceOfDestination === "CLIENT_FIX" && (
            <>
              {" "}
              {partnerConfig} has partnered up with Manifest to make your transfer as seamless as possible. <br />
            </>
          )}
          {sourceOfDestination !== "CLIENT_FIX" && (
            <>
              Since we’ve partnered with {partnerConfig}, you can transfer directly into an {partnerConfig} account, or
              let Manifest help you choose the best option.
            </>
          )}
        </p>
        <Button onClick={onClickContinue} name="continue" size="large">
          Continue
        </Button>
      </Footer>
    </TransitionWrapper>
  );
};

export default OldAccountFinishScreen;
